import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { Subject } from 'rxjs';

import { ReportType } from '../../shared/enums/report-type.enum';
import { WindowRefService } from './window-ref.service';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  csvFileSaved$: Subject<boolean> = new Subject<boolean>();

  constructor(
    @Inject(DOCUMENT) private document: HTMLDocument,
    private windowRefService: WindowRefService,
  ) {
  }

  saveCsvReport(response, reportType) {
    const headers = response.headers;
    const blob = new Blob([ response.body ], { type: headers.get('content-type') });
    const link = this.document.createElement('a');
    link.href = this.windowRefService.window.URL.createObjectURL(blob);
    link.download = `${ReportType[reportType]}.csv`;
    link.click();

    this.csvFileSaved$.next(true);
  }
}
